import { Outlet } from '@tanstack/react-router'

export const DriverRechargeLayout = (): React.ReactNode => {
    return <Outlet />
}
